import { KycType } from '@views/health/kyc/types';

export const healthEndPoints = {
  // quote
  validatePincode: '/health/city',
  verifyPincode: '/health/verify-pincode',
  boundaries: '/health/v2/product/boundaries',
  features: '/health/v2/product/features',
  suggestion: '/health/v2/cover/suggestion',
  premium: '/health/v2/premium',
  estimate: '/health/v2/premium/estimate',
  // todo - upgrade to v2
  finalize: '/health/product',
  policyInfo: '/health/renewal/policy-information',
  healthRenewalPremium: '/health/renewal/premium',
  finalizeMigrationHealthQuote: '/health/renewal/product',

  // Share policy details
  sharePolicyDocument: (policyId: string) =>
    `/health/policy/${policyId}/share-policy-document`,

  // status
  status: (policyId: string) => `/health/status/${policyId}`,

  //compare premium change
  comparePremiumChange: (policyId: string) =>
    `/health/v2/compare-premium-change/${policyId}`,

  // proposal
  proposal: (policyId: string) => `/health/proposal/${policyId}`,
  proposalSubmit: (policyId: string) => `/health/proposal/${policyId}/submit`,
  // confirm counter offer
  confirmCounterOffer: (policyId: string) =>
    `/health/proposal/${policyId}/confirm-co`,

  // proposal -> abhi
  adityaBirlaPincodeData: (pincode: string, product: string) =>
    `/health/aditya-birla/pincode/data?pincode=${pincode}&product=${product}`,

  // proposal - nivabupa
  nivaBupaBankNames: (ifscCode: string) =>
    `/health/maxbupa/bank-details/${ifscCode}`,
  // proposal - ergo
  ergoBankNames: (bankName: string, product: string) =>
    `/health/ergo/getBankNames?search=${bankName}&product=${product}`,
  ergoBankNamesByIFSC: (ifscCode: string, product: string) =>
    `/health/ergo/getBankNames?ifsc=${ifscCode}&product=${product}`,
  ergoEnergySilverArea: (pincode: string) =>
    `/health/energy-silver/area?pincode=${pincode}`,
  ergoCityState: (pincode: string, product: string) =>
    `/health/city?pincode=${pincode}&product=${product}`,
  ergoOptimaCityState: (pincode: string, product: string) =>
    `health/optima/pincode/data?pincode=${pincode}&product=${product}`,
  carePincodeData: (pincode: string, product: string) =>
    `/health/care/pincode/data?pincode=${pincode}&product=${product}`,

  //kyc
  initiateEKYC: (policyId: string) => `/health/kyc/get-ekyc-url/${policyId}`,
  completeKycUsingPhysicalDoc: (policyId: string) =>
    `/health/kyc/doc-upload/${policyId}`,
  getKycInfo: (policyID: string, kyc_type: KycType) =>
    `/health/kyc/verify-details/${kyc_type}/${policyID}`,

  // Get Pre-Signed URL for S3 upload - used for kyc, porting
  getPreSignedURL: (policyID: string) => `/health/presigned-url/${policyID}`,

  // Porting documents
  submitPortingDocument: (policyId: string) =>
    `/health/porting/${policyId}/doc-upload`,
  getUploadedPortingDocumentKeys: (policyId: string) =>
    `/health/porting/${policyId}/get-doc-keys`,

  // Summary PDF
  verifySummaryToken: () => `/health/proposal/verify-summary-token`
};
